import React from 'react';
import cls from 'classnames';
import { Input } from 'reactstrap';
import './From.scss';
import { prop } from 'lodash/fp';

/**
 * @param {object} props
 * @param {boolean} disabled
 */

function CusInput({
  children,
  disable,
  readonly,
  ...props
}) {
  return (
    <div className={cls(
      "CusInput w-100",
      disable ? 'CusInput_disabled' : '',
      readonly ? 'CusInput_readonly' : '',
    )}>
      {props.label ? <span className="CusInput__label mb-2">{props.label}</span> : null}
      <Input
        {...props}
        className={cls(
          'p-0 w-100',
          props.className
        )}
        maxLength={props.maxLength}
        innerRef={props.innerRef}
        onKeyPress={props.onKeyPress}
      >
        {children}
      </Input>
      {props.icon}
    </div>
  );
}

export { CusInput };
